module.exports = __webpack_public_path__ + "media/images/sp/stores/nagoya/access/nagoya_point1_6-542f3d32d9c2767a756380b375735a14.jpg";